/* eslint-disable jsx-a11y/anchor-is-valid */
import AmpService from "analytics/amplitude/amplitudeEvents";
import { getCategoryCanonicalUrlV2 } from "api/category/getCategoryCanonicalUrlV2";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import PAButton, { BUTTON_SIZE, BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import styles from "./view-correct-part-button.module.scss";

interface IProps {
  product: ICompactProduct;
  href: string;
  asPath: string;
  fullWidth?: boolean;
  className?: string;
  correctPartButtonText?: string;
  correctPartButtonType?: typeof BUTTON_TYPE;
  categoryUrl: string;
}

function ViewCorrectPartButton(props: IProps) {
  const {
    product, href, asPath, fullWidth = false, className = "",
    correctPartButtonText = "BROWSE PARTS THAT FIT",
    correctPartButtonType = BUTTON_TYPE.SUCCESS,
    categoryUrl,
  } = props;
  const { t } = useTranslation("product");
  const { selectedVehicle, isCompleteVehicleSelected, isLoading } = useSelector((store: RootState) => store.garage);
  const [correctPartButtonUrl, setCorrectPartButtonUrl] = useState({ href, asPath });
  const { useVehicleSelectionOptionsModal } = useSelector((store: RootState) => store.utils);

  useEffect(() => {
    async function getCategoryUrl() {
      if (!isLoading && useVehicleSelectionOptionsModal && categoryUrl && product.category && !isCompleteVehicleSelected) {
        const { data } = await getCategoryCanonicalUrlV2(product.category, selectedVehicle, categoryUrl);
        const { url, success, queryParams } = data;
        if (success) {
          const { href: apiHref, asPath: apiAsPath } = getHrefAndPath({
            query: { ...queryParams }, asPath: url,
          });
          setCorrectPartButtonUrl({ href: apiHref, asPath: apiAsPath });
        }
      } else {
        setCorrectPartButtonUrl({ href, asPath });
      }
    }

    getCategoryUrl();
  }, [categoryUrl, product.category, isLoading, href, asPath]);

  if (!product.category) {
    return null;
  }

  const handleBrowsePartsClick = () => {
    AmpService.guaranteedFitProduct({ vehicle: selectedVehicle, skuWhichDoesnotFit: product.sku }, "BROWSE_PARTS_CLICKED");
  };

  return (
    <>
      <Link href={correctPartButtonUrl.href} as={correctPartButtonUrl.asPath} className={className}>

        <PAButton
          className={`btn ${styles.correctCategoryBtn} 
          ${correctPartButtonType === BUTTON_TYPE.SUCCESS ? styles.success_btn : styles.outline_btn}`}
          size={BUTTON_SIZE.MEDIUM}
          buttonType={correctPartButtonType}
          fullWidth={fullWidth}
          onClick={handleBrowsePartsClick}
        >
          {t(correctPartButtonText)}
        </PAButton>
      </Link>
    </>
  );
}

export default ViewCorrectPartButton;
